import * as React from 'react';

import {createIcon} from '@chakra-ui/icons';

/** Tonos de la escala darkBlue del theme, del frente más viejo al más nuevo. */
const TONOS_ONDA = ['#B8CDDF', '#6381A1', '#385B82', '#0E3663'];

/**
 * Los frentes mueren en scale 1.55 (radio 9.3), justo dentro del borde blanco:
 * así no hace falta recortarlos y el icono no depende de un `clipPath` con id,
 * que se rompería al desmontarse la primera tarjeta que lo declara.
 * La animación vive en Calendar.css (`.evento-onda`).
 */
export const eventoEnProgresoPath = (
  <>
    <circle
      cx='12'
      cy='12'
      r='10.5'
      fill='#E3F3FF'
      stroke='#FFFFFF'
      strokeWidth='2'
    />
    {TONOS_ONDA.map((color, i) => (
      <circle
        key={color}
        className={`evento-onda evento-onda-${i}`}
        cx='12'
        cy='12'
        r='6'
        fill={color}
      />
    ))}
  </>
);

export const EventoEnProgresoIcon = createIcon({
  displayName: 'EventoEnProgresoIcon',
  viewBox: '0 0 24 24',
  path: eventoEnProgresoPath,
});
